package br.com.htms.inspeccaocampo.data

object AlojamentoValidacao {

    fun validarRelatorio(form: FormRelatorioFoto): List<ErroCampo> {
        val erros = mutableListOf<ErroCampo>()
        if (form.responsavelAlojamento.isBlank()) {
            erros += ErroCampo("responsavelAlojamento", "Informe o responsável pelo alojamento.")
        }
        if (form.endereco.isBlank()) {
            erros += ErroCampo("endereco", "Informe o endereço.")
        }
        if (form.dataInicioContrato.isBlank()) {
            erros += ErroCampo("dataInicioContrato", "Informe a data de início do contrato.")
        }
        if (form.obra.isBlank()) {
            erros += ErroCampo("obra", "Selecione a obra.")
        }
        if (form.latitude == null || form.longitude == null) {
            erros += ErroCampo("localGps", "Capture o local por GPS.")
        }
        listOf(
            Triple("capacidadeTotalPessoas", form.capacidadeTotalPessoas, "Capacidade total de pessoas"),
            Triple("quantidadeFuncionarios", form.quantidadeFuncionarios, "Quantidade de funcionários"),
            Triple("quantidadeQuartos", form.quantidadeQuartos, "Quantidade de quartos"),
            Triple("quantidadeCamas", form.quantidadeCamas, "Quantidade de camas"),
            Triple("quantidadeArmarios", form.quantidadeArmarios, "Quantidade de armários"),
            Triple("quantidadeBanheiros", form.quantidadeBanheiros, "Quantidade de banheiros")
        ).forEach { (campo, valor, rotulo) ->
            when {
                valor.isBlank() -> erros += ErroCampo(campo, "Informe $rotulo (somente números).")
                valor.any { !it.isDigit() } ->
                    erros += ErroCampo(campo, "$rotulo deve conter somente números.")
            }
        }

        form.itens.forEach { item ->
            validarItemConformidade(
                erros = erros,
                item = item,
                exigirFoto = item.fotoHabilitada && item.fotoObrigatoria,
                exigirExtra = item.tipoExtra != TipoCampoExtra.NENHUM,
                rotuloOpcoes = "Sim, Não ou N/A"
            )
        }

        // 8. Observações Gerais: não obrigatória; se houver foto, exigir texto.
        if (form.observacoesFotos.isNotEmpty() && form.observacoesGerais.isBlank()) {
            erros += ErroCampo(
                "observacoesGerais",
                "Com foto em Observações Gerais, descreva a observação."
            )
        }
        return erros
    }

    fun validarChecklist(form: FormChecklistAlojamento): List<ErroCampo> {
        val erros = mutableListOf<ErroCampo>()
        if (form.endereco.isBlank()) {
            erros += ErroCampo("endereco", "Informe o endereço.")
        }
        if (form.obra.isBlank()) {
            erros += ErroCampo("obra", "Selecione a obra.")
        }
        if (form.latitude == null || form.longitude == null) {
            erros += ErroCampo("localGps", "Capture o local por GPS.")
        }
        form.itens.forEach { item ->
            validarItemConformidade(
                erros = erros,
                item = item,
                exigirFoto = false,
                exigirExtra = false,
                rotuloOpcoes = "C, NC ou NA"
            )
        }
        if (form.liberadoParaUso == null) {
            erros += ErroCampo("liberadoParaUso", "Informe se está liberado para uso (Sim/Não).")
        }
        if (form.inspecionadoPor.nome.isBlank()) {
            erros += ErroCampo("inspecionadoPorNome", "Informe o nome de quem inspecionou.")
        }
        if (form.inspecionadoPor.assinatura.isBlank()) {
            erros += ErroCampo("inspecionadoPorAss", "Assinatura do inspecionado é obrigatória.")
        }
        return erros
    }

    private fun validarItemConformidade(
        erros: MutableList<ErroCampo>,
        item: ItemConformidade,
        exigirFoto: Boolean,
        exigirExtra: Boolean,
        rotuloOpcoes: String
    ) {
        when (item.resposta) {
            null -> {
                if (item.obrigatorio) {
                    erros += ErroCampo(
                        item.id,
                        "Selecione $rotuloOpcoes para \"${item.tituloNumerado}\"."
                    )
                }
            }
            RespostaConformidade.C -> {
                if (exigirFoto && item.fotos.isEmpty()) {
                    erros += ErroCampo(item.id, "Adicione foto para \"${item.tituloNumerado}\".")
                }
                if (exigirExtra && item.valorExtra.isBlank()) {
                    erros += ErroCampo(
                        item.id,
                        "Informe ${item.labelExtra.ifBlank { "o valor" }} em \"${item.tituloNumerado}\"."
                    )
                } else if (exigirExtra &&
                    item.tipoExtra == TipoCampoExtra.NUMERO &&
                    item.valorExtra.any { !it.isDigit() && it != ',' && it != '.' }
                ) {
                    erros += ErroCampo(item.id, "${item.labelExtra} deve ser numérico.")
                }
            }
            RespostaConformidade.NC, RespostaConformidade.NA -> {
                val rotuloResposta = if (rotuloOpcoes.startsWith("Sim")) {
                    item.resposta.rotuloSimNao
                } else {
                    item.resposta.codigo
                }
                if (item.justificativa.isBlank()) {
                    erros += ErroCampo(
                        item.id,
                        "Justificativa obrigatória para \"${item.tituloNumerado}\" ($rotuloResposta)."
                    )
                }
                if (exigirFoto && item.fotos.isEmpty() && item.resposta == RespostaConformidade.NC) {
                    erros += ErroCampo(item.id, "Adicione foto para \"${item.tituloNumerado}\".")
                }
            }
        }
    }
}
